<template>
  <div class="">
    <el-card class="user-card">
      <div slot="header"
           class="clearfix">
        <span>账户资料</span>
      </div>
      <!-- <div class="info"> -->
        <el-form ref="data"
                :model="data"
                status-icon
                label-width="70px"
                class="user-info">
          <el-form-item label="头像">
            <div class="user-img" @mouseenter="imgModal = true" @mouseleave="imgModal = false">
              <img :src="data.headImg" alt="">
              <span v-if="imgModal" class="img-hover" @click="editHead">编辑头像</span>
            </div>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input v-model="data.account" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="data.email" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="手机">
            <el-input v-model="data.mobile" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input v-model="data.password" type="password" size="mini" disabled></el-input>
            <el-link type="primary" :underline="false" @click="changePwd">修改密码</el-link>
          </el-form-item>
          <el-form-item label="公司">
            <el-input size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-input size="mini" disabled></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input size="mini" disabled></el-input>
          </el-form-item>
        </el-form>
      <!-- </div> -->
      <div class="btnmg">
          <el-button type="primary" size="mini" @click="submitForm('data')">保存修改</el-button>
          <el-button size="mini" @click="resetForm('data')">{{ $t('menu.cancel') }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'userInfo',
  data() {
    return {
      data: {},
      imgModal: false
    }
  },
  computed: {
    head() {
      return this.$store.state.userHead
    }
  },
  watch: {
    head() {
      this.data.headImg = this.$store.state.userHead
    }
  },
  created() {
    this.data = JSON.parse(localStorage.user)
  },
  methods: {
    
    editUser() {
      const params = {
        masterDeptId: 1,
        account: this.info.account,
        name: this.info.name,
        userCreatorId: this.$store.getters.baseInfo.userId,
        password: '1234',
        email: this.info.email,
        gender: this.info.gender,
        birthday: this.info.birthday,
        telephone: this.info.telephone,
        mobile: this.info.mobile
      }
      ApiService.octopus_user.editUser(params).then(res => {
        this.closeDialog()
      })
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            userAccount: this.data.account,
            userGuid: this.data.userId,
            userPassword: this.data.password,
            userLang: '',
            userName: this.data.name,
            userGender: this.data.gender,
            userRoleID: this.data.role,
            userRoleName: '',
            userTelephone: this.data.telephone,
            userMobile: this.data.mobile,
            userStatus: this.data.status
          }
          ApiService.octopus_user.editUser(params).then(res => {
            if (res.code === 0) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 取消、关闭
    resetForm(formName) {
      if (formName) {
        this.$refs[formName].resetFields()
      }
      this.$store.commit('closeModal', 'userInfo')
    },
    changePwd() {
      this.$store.commit('showModal', {
        name: 'changePwd',
        show: true,
        top: '3rem'
      })
    },
    editHead() {
      this.$store.commit('showModal', {
        name: 'changeHead',
        show: true,
        top: '2rem',
        left: '40%',
        data: ''
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../common/css/color.scss';
.user-card {
  width: 560px;
  .user-info {
    .el-form-item__content {
      display: flex;
      .user-img {
        width: 66px;
        height: 66px;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .img-hover {
          position: absolute;
          width: 66px;
          height: 66px;
          border-radius: 50%;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          background: rgba(0, 0, 0, .65);
        }
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .el-input {
        width: 50%;
      }
      .el-link {
        margin-left: 20px;
      }
    }
  }
  .info {
    display: flex;
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/userInfo.vue